export default __webpack_public_path__ + "8feae44ffeeacd1b0fcff147f6851852.svg";